import { ButtonOutline } from '@lambdacurry/component-library';
import { Link } from 'gatsby';
import { SubscriptionFrequency } from 'lib/home/generated/types/api';
import { Card, CardActions, CardContent } from 'lib/components';
import { SUBSCRIPTION_FREQUENCIES } from '../../../util/constants';

interface CurrentOrderSkippedProps {
  frequency: SubscriptionFrequency;
  unskip: () => void;
}

export const CurrentOrderSkipped = ({ frequency, unskip }: CurrentOrderSkippedProps) => (
  <Card className="current-order-skipped-box bg-brand-dark-green-500 text-white z-10 max-w-xsf md:max-w-md lg:max-w-lg">
    <CardContent>
      <h3>You have skipped this week's box.</h3>
      {frequency !== SubscriptionFrequency.OneWeek && (
        <p>
          Your delivery frequency is set to every {SUBSCRIPTION_FREQUENCIES[frequency]} weeks. Want to go back to
          weekly? You can change it in your <Link to="/account">account settings</Link>
        </p>
      )}
      <CardActions className="mt-8">
        <ButtonOutline className="current-order-unskip" onClick={unskip}>
          Unskip this week
        </ButtonOutline>
      </CardActions>
    </CardContent>
  </Card>
);
